"use client";
import React, { useState } from "react";
import styled from "styled-components";
import { Col, Container, Modal, Row } from "react-bootstrap";
import TeamSingle from "@/components/about/TeamSingle";
import Title from "../Title";
import SimpleBar from "simplebar-react";
// import "simplebar-react/dist/simplebar.min.css";
import TitleSerial from "@/components/TitleSerial";
import reactHtmlParser from "react-html-parser";
import Link from "next/link";

const MyComponent = ({ data, sectionID }) => {
  const [activeCategory, setActiveCategory] = useState("All");

  const handleCategoryClick = (category) => {
    setActiveCategory(category);
  };

  const [show, setShow] = useState(false);
  const [selectedTeamMember, setSelectedTeamMember] = useState(null);
  const handleClose = () => {
    setShow(false);
    setSelectedTeamMember(null); // Clear the selected team member data when closing the modal
  };
  const handleShow = (teamMember) => {
    setSelectedTeamMember(teamMember); // Set the selected team member data
    setShow(true);
  };


  return (
    <StyledComponent
      id={`${sectionID ? sectionID : ""}`}
      className={"team-list pt-200 pb-120"}
    >
      <Container>
        {/*<Row>*/}
        {/*  <Col md={{ offset: 6, span: 6 }}>*/}
        {/*    <TitleSerial text={"III"} />*/}
        {/*    <Title number={"III"} />*/}
        {/*  </Col>*/}
        {/*</Row>*/}

        {data?.title && (
          <Row>
            <Col sm={12} className={'d-flex align-items-center'}>
              <TitleSerial line margin={"0 0 0 0 "} text={"III"}/>
              <h2 className={"split-left section-title"}>Board of Directors</h2>
            </Col>
          </Row>
        )}

        <Row className={"team-list__wrapper fade-up"}>
          {data?.list &&
            data?.list?.length > 0 &&
            data?.list?.map((e, index) => (
              <Col md={3} key={index} onClick={() => handleShow(e)}>
                <TeamSingle
                  title={e?.name}
                  deg={e?.designation}
                  img={e?.image}
                />
              </Col>
            ))}
        </Row>
      </Container>

      <Modal
        className={"team-modal custom-as-team"}
        show={show}
        onHide={handleClose}
      >
        <div className="team-modal__close" onClick={handleClose}>
          <svg
            id="Cross"
            xmlns="http://www.w3.org/2000/svg"
            width="44"
            height="44"
            viewBox="0 0 44 44"
          >
            <g
              id="Rectangle_492"
              data-name="Rectangle 492"
              fill="none"
              stroke="#fff"
              strokeWidth="1"
              opacity="0.2"
            >
              <rect width="44" height="44" rx="22" stroke="#FFF" />
              <rect
                x="0.5"
                y="0.5"
                width="43"
                height="43"
                rx="21.5"
                fill="none"
              />
            </g>
            <g
              id="Group_Cross"
              data-name="Group Cross"
              transform="translate(17 17)"
            >
              <line
                id="Line_1"
                data-name="Line 1"
                x2="8"
                y2="8"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeWidth="1"
              />
              <line
                id="Line_2"
                data-name="Line 2"
                x1="8"
                y2="8"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeWidth="1"
              />
            </g>
            <g
              id="Rectangle_5661"
              data-name="Rectangle 5661"
              transform="translate(0 44) rotate(-90)"
              fill="none"
              stroke="#fff"
              strokeWidth="1"
              stroke-dasharray="1 140"
              opacity="0"
            >
              <rect width="44" height="44" rx="22" stroke="none" />
              <rect
                x="0.5"
                y="0.5"
                width="43"
                height="43"
                rx="21.5"
                fill="none"
              />
            </g>
          </svg>
        </div>

        <SimpleBar style={{ maxHeight: "calc(100vh - 130px)" }}>
          <div className="team-modal__content">
            {selectedTeamMember && (
              <>
                <img
                  src={selectedTeamMember.image}
                  alt={selectedTeamMember.name}
                />
                <div className="name-social">
                  <div className="name">
                    <h4>{reactHtmlParser(selectedTeamMember.name)}</h4>
                    <h5>{reactHtmlParser(selectedTeamMember.designation)}</h5>
                  </div>
                  <div className="social">
                    <ul className={"footer__social"}>
                      {selectedTeamMember.facebook && (
                        <li>
                          <Link  prefetch={true}
                            target={"_blank"}
                            href={`${selectedTeamMember.facebook}`}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="6.539"
                              height="12.208"
                              viewBox="0 0 6.539 12.208"
                            >
                              <path
                                id="Path_2115"
                                data-name="Path 2115"
                                d="M1204.9,102.967l.339-2.21h-2.12V99.323a1.1,1.1,0,0,1,1.246-1.194h.964V96.248a11.752,11.752,0,0,0-1.711-.149,2.7,2.7,0,0,0-2.887,2.974v1.684h-1.941v2.21h1.941v5.341h2.388v-5.341Z"
                                transform="translate(-1198.787 -96.099)"
                                fill="#fff"
                              />
                            </svg>
                          </Link>
                        </li>
                      )}

                      {selectedTeamMember.x && (
                        <li>
                          <Link  prefetch={true}
                            target={"_blank"}
                            href={`${selectedTeamMember.x}`}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="11.035"
                              height="10.328"
                              viewBox="0 0 11.035 10.328"
                            >
                              <path
                                id="path1009"
                                d="M281.527,167.31l4.26,5.7-4.287,4.632h.965l3.754-4.055,3.033,4.055h3.284l-4.5-6.017,3.991-4.311h-.965l-3.457,3.735-2.793-3.735Zm1.419.711h1.509l6.661,8.907h-1.509Z"
                                transform="translate(-281.5 -167.31)"
                                fill="#fff"
                              />
                            </svg>
                          </Link>
                        </li>
                      )}

                      {selectedTeamMember.instagram && (
                        <li>
                          <Link
                            target={"_blank"}
                            href={`${selectedTeamMember.instagram}`}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="12.133"
                              height="12.133"
                              viewBox="0 0 12.133 12.133"
                            >
                              <g
                                id="Group_25659"
                                data-name="Group 25659"
                                transform="translate(-1084.666 -6273.667)"
                              >
                                <path
                                  id="Path_2109"
                                  data-name="Path 2109"
                                  d="M1095.627,105.945a.711.711,0,1,0,.711.712A.711.711,0,0,0,1095.627,105.945Z"
                                  transform="translate(-1.682 6169.889)"
                                  fill="#fff"
                                />
                                <path
                                  id="Path_2110"
                                  data-name="Path 2110"
                                  d="M1082.043,108.605a2.988,2.988,0,1,0,2.988,2.988A2.992,2.992,0,0,0,1082.043,108.605Zm0,4.9a1.914,1.914,0,1,1,1.914-1.914A1.916,1.916,0,0,1,1082.043,113.507Z"
                                  transform="translate(8.74 6168.141)"
                                  fill="#fff"
                                />
                                <path
                                  id="Path_2111"
                                  data-name="Path 2111"
                                  d="M1078.421,111.761h-4.844a3.649,3.649,0,0,1-3.645-3.645v-4.844a3.649,3.649,0,0,1,3.645-3.644h4.844a3.649,3.649,0,0,1,3.645,3.644v4.844A3.649,3.649,0,0,1,1078.421,111.761Zm-4.844-10.992a2.506,2.506,0,0,0-2.5,2.5v4.844a2.506,2.506,0,0,0,2.5,2.5h4.844a2.506,2.506,0,0,0,2.5-2.5v-4.844a2.506,2.506,0,0,0-2.5-2.5Z"
                                  transform="translate(14.734 6174.039)"
                                  fill="#fff"
                                />
                              </g>
                            </svg>
                          </Link>
                        </li>
                      )}

                      {selectedTeamMember.youtube && (
                        <li>
                          <Link
                            target={"_blank"}
                            href={`${selectedTeamMember.youtube}`}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="10.685"
                              height="7.479"
                              viewBox="0 0 10.685 7.479"
                            >
                              <path
                                id="Path_2114"
                                data-name="Path 2114"
                                d="M1144.76,112.662a2.345,2.345,0,0,0-2.345-2.345h-6a2.345,2.345,0,0,0-2.344,2.345v2.79a2.345,2.345,0,0,0,2.344,2.345h6a2.345,2.345,0,0,0,2.345-2.345Zm-3.526,1.6-2.689,1.33c-.105.057-.463-.019-.463-.139v-2.73c0-.121.361-.2.466-.137l2.574,1.4C1141.23,114.051,1141.343,114.207,1141.234,114.266Z"
                                transform="translate(-1134.075 -110.317)"
                                fill="#fff"
                              />
                            </svg>
                          </Link>
                        </li>
                      )}

                      {selectedTeamMember.linkedin && (
                        <li>
                          <Link
                            target={"_blank"}
                            href={`${selectedTeamMember.linkedin}`}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="10.314"
                              height="10.313"
                              viewBox="0 0 10.314 10.313"
                            >
                              <g
                                id="Group_25659"
                                data-name="Group 25659"
                                transform="translate(-1165.5 -6274.5)"
                              >
                                <path
                                  id="Path_2123"
                                  data-name="Path 2123"
                                  d="M44.965,42.352V38.575c0-1.856-.4-3.275-2.565-3.275a2.239,2.239,0,0,0-2.024,1.109H40.35v-.941H38.3v6.884h2.14V38.936c0-.9.168-1.766,1.276-1.766s1.109,1.018,1.109,1.818v3.352h2.14Z"
                                  transform="translate(1130.849 6242.461)"
                                  fill="#fff"
                                />
                                <path
                                  id="Path_2124"
                                  data-name="Path 2124"
                                  d="M11.3,36.6h2.14v6.884H11.3Z"
                                  transform="translate(1154.367 6241.329)"
                                  fill="#fff"
                                />
                                <path
                                  id="Path_2125"
                                  data-name="Path 2125"
                                  d="M11.238,10a1.244,1.244,0,1,0,1.238,1.238A1.238,1.238,0,0,0,11.238,10Z"
                                  transform="translate(1155.5 6264.5)"
                                  fill="#fff"
                                />
                              </g>
                            </svg>
                          </Link>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>

                <p>
                  {" "}
                  {selectedTeamMember?.description &&
                    reactHtmlParser(selectedTeamMember?.description)}
                </p>
              </>
            )}
          </div>
        </SimpleBar>
      </Modal>
    </StyledComponent>
  );
};

const StyledComponent = styled.section`
  background-color: #f4f4f4;

  h2.section-title {
    font-size: 36px;
    line-height: 40px;
    font-weight: 600;
    margin-top: 0;
  }

  .title {
    &:after {
      bottom: 0;
    }

    @media (max-width: 767px) {
      h2 {
        margin-top: 40px;
      }

      &:after {
        bottom: -110px;
      }
    }
  }

  .top {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 30px;
    padding-bottom: 60px;

    &:after {
      position: absolute;
      content: "";
      top: 0;
      left: 0;
      height: 1px;
      width: 100%;
      background-color: rgba(37, 41, 44, 0.2);
    }

    &:before {
      position: absolute;
      content: "";
      top: -1px;
      left: 0;
      height: 3px;
      width: 70px;
      background-color: #ff8900;
      border-radius: 10px;
    }

    &__right {
      //display: flex;
      //flex-wrap: wrap;
      //gap: 30px;

      .filter {
        ul {
          display: flex;
          gap: 30px;
          justify-content: flex-start;
          align-items: center;
          flex-wrap: wrap;

          li {
            position: relative;
            overflow: hidden;
            padding: 10px 20px;
            border: 1px solid #acacac;
            border-radius: 23px;
            cursor: pointer;
            color: #25292c;
            transition: color 0.3s ease-in-out;

            &:after {
              content: "";
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
              height: 0;
              background-color: #25292c;
              transition: height 0.3s ease-in-out;
              z-index: -1;
            }

            &.active {
              color: #ffffff !important;
              z-index: 2;
              transition: color 0.3s ease-in-out;
              &:after {
                height: 100%;
                transition: 0.3s ease-in-out;
              }
            }

            &:hover {
              color: #ffffff !important;
              z-index: 2;
              transition: color 0.3s ease-in-out;
              &:after {
                height: 100%;
                transition: 0.3s ease-in-out;
              }
            }
          }
        }
      }
    }
  }

  .col-sm-4 {
    margin-bottom: 60px;

    &:nth-last-child(-n + 4) {
      margin-bottom: 0;
    }

    @media (max-width: 767px) {
      margin-bottom: 40px;
      &:nth-last-child(-n + 4) {
        margin-bottom: 40px;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  @media (max-width: 767px) {
    .top {
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      gap: 40px;

      &__right {
        gap: 20px;
      }
    }
  }

  h2 {
    margin-top: 80px;
  }

  .team-list__wrapper {
    margin-top: 60px;

    .col-md-3 {
      margin-bottom: 40px;
    }
    @media (max-width: 767px) {
      display: flex;
      flex-wrap: wrap;
      .col-md-3 {
        width: calc(50%);
        margin-bottom: 30px;
      }
    }
  }
`;

export default MyComponent;
